export class GoogleConfig {
    apiKey: string;
    clientId: string;
    serviceAccount: string;
    constructor(data) {
        this.apiKey = data.apiKey;
        this.clientId = data.clientId;
        this.serviceAccount = data.serviceAccount;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/info-expense/google-config.ts